import angular from 'angular';
import prettyImg from './prettyImg';

export default angular
  .module('component.prettyImg', [])
  .component('prettyImg', prettyImg).name;
